module.exports = __webpack_public_path__ + "img/Seychelles.e5c24a67.svg";